export default __webpack_public_path__ + "static/media/Valvina_Miguel.ed885bff.jpeg";